import React from 'react';
import InformationComponent from '../components/informationComponent';

const InformationContainer = () => {
  return <InformationComponent />;
};

export default InformationContainer;
